module.exports = __webpack_public_path__ + "static/img/2025年历-2.b31a687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-2.png
// module id = /nu7
// module chunks = 3